import { Image } from 'expo-image';
import { router } from 'expo-router';
import { useCallback, useMemo } from 'react';
import { useWindowDimensions } from 'react-native';
import { StyleSheet, View } from 'react-native';

import {
  ActionSheet,
  ActionSheetScreenHeader,
  Button,
  MediaQueriesContext,
  ScrollView,
  mobileMediaQueries,
  tokens,
  useMqSelect,
} from '@fhs/ui';
import { useLocale } from '@fhs-legacy/frontend/src/state/intl';
import { REGIONS } from '@fhs-legacy/frontend/src/state/intl/types';

import { BottomButtonContainer } from '../offer-guide/bottom-button';

import { EligibilityRules } from './eligibility-rules';
import { RedemptionAvailability } from './redemption-availability';
import { RedemptionRules } from './redemption-rules';

export function BirthdayScreen() {
  const { region } = useLocale();
  const { height: screenHeight } = useWindowDimensions();
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);
  const containerStyle = isDesktop ? { height: screenHeight } : ({ height: '100%' } as const);
  const drawerProps = useMemo(() => ({ style: { flex: 1 } }), []);

  const birthdayImage = useMemo(
    () =>
      region === REGIONS.CA
        ? require('./birthday-reward-ca.png')
        : require('./birthday-reward.png'),
    [region]
  );

  const onClose = useCallback(() => {
    router.dismiss();
  }, []);

  return (
    <ActionSheet
      onRequestClose={onClose}
      isVisible
      onClose={onClose}
      containerStyle={containerStyle}
      ignoreBottomSafeArea
      drawerProps={drawerProps}
    >
      <MediaQueriesContext.Provider value={mobileMediaQueries}>
        <ActionSheetScreenHeader title="Birthday Reward" />
        <ScrollView showsVerticalScrollIndicator={false} bounces={false}>
          <Image
            contentFit="cover"
            source={birthdayImage}
            style={{ width: '100%', aspectRatio: 13 / 5 }}
          />
          <View style={styles.content}>
            <EligibilityRules />
            <View style={styles.separator} />
            <RedemptionAvailability />
            <View style={styles.separator} />
            <RedemptionRules isCanada={region === REGIONS.CA} />
          </View>
        </ScrollView>
        <BottomButtonContainer>
          <Button onPress={onClose} size="xl">
            <Button.Text>Close</Button.Text>
          </Button>
        </BottomButtonContainer>
      </MediaQueriesContext.Provider>
    </ActionSheet>
  );
}

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 16,
  },
  separator: {
    height: 1,
    width: '100%',
    backgroundColor: tokens.colors.$blackOpacity04,
    marginTop: 24,
  },
});
